import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

/**
 * ECommerceApiKeyInterceptor
 *
 * Auto-injects `x-api-key: <ANGULAR_API_KEY>` into every request whose URL
 * targets the NestJS e-commerce backend (`environment.apiECommerce`).
 *
 * Centralising this here means feature services do NOT need to set the
 * header manually. The Bearer token (CRM JWT) is still set explicitly by
 * each service from localStorage, to avoid leaking it to other origins.
 */
@Injectable()
export class ECommerceApiKeyInterceptor implements HttpInterceptor {
  private readonly target = environment.apiECommerce;
  private readonly apiKey = environment.apiECommerceKey;

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const isECommerceRequest = req.url.startsWith(this.target);
    const alreadyHasKey = req.headers.has('x-api-key');

    if (!isECommerceRequest || alreadyHasKey || !this.apiKey) {
      return next.handle(req);
    }

    const cloned = req.clone({
      headers: req.headers.set('x-api-key', this.apiKey),
    });
    return next.handle(cloned);
  }
}
